import { TableCell } from '@/components/ui';
import { IPaymentInfo } from '@/interfaces';
import { PaymentMethodEnum } from '@/enums';

type TProps = {
  paymentInfo?: IPaymentInfo;
}

export const DataTableBodyCellPaymentInfoDetails = ({ paymentInfo }: TProps) => (
  <TableCell className='py-1 pe-0'>
    {
      paymentInfo?.method === PaymentMethodEnum.BANK_TRANSFERT &&
      [paymentInfo.iban, paymentInfo.bic].filter(l => l).join(' • ')
    }
    {
      paymentInfo?.method === PaymentMethodEnum.MOBILE_MONEY &&
      [paymentInfo.phoneNumber, paymentInfo.phoneNumberOwnerName].filter(l => l).join(' • ')
    }
    {
      paymentInfo?.method === PaymentMethodEnum.PAYPAL &&
      paymentInfo.email
    }
  </TableCell>
);

export default DataTableBodyCellPaymentInfoDetails;
